export { default } from "./PermissionWarningIcon";
